/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataStructureGraphIcon20Solid = forwardRef('DataStructureGraphIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2 5.25A3.25 3.25 0 0 1 5.25 2h6.5a3.25 3.25 0 0 1 0 6.5h-1.51l2.4 3h2.11a3.25 3.25 0 0 1 0 6.5h-6.5a3.25 3.25 0 0 1 0-6.5h1.51l-2.4-3H5.25A3.25 3.25 0 0 1 2 5.25Z" })));
});
